import { Button, Col, Row } from 'react-bootstrap';
import { BsDownload } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { QuestionnaireService, UserTypeEnum } from '../../../api';
import { Card } from '../../../app/components/Card';
import { useCurrentUser } from '../../../app/hooks/auth';
import { useProvider } from '../../../app/hooks/providers';
import { useDocumentTitle } from '../../../app/hooks/use-document-title';

export const Other = () => {
  useDocumentTitle('Provider Other Information');
  const { user } = useCurrentUser();
  const { provider } = useProvider();

  const downloadQuestionnaire = async (provider_id: string) => {
    const { url } = await QuestionnaireService.questionnairePdfRetrieve({
      providerId: provider_id,
    });

    window.open(url, '_blank');
  };

  return (
    <Row>
      <Col xs={12} md={6} className="mb-3">
        <Card.SubCard className="p-3 pb-0 mb-3">
          <div className="p-3">
            <h5 className="pb-3 m-0">Insurance Certificates</h5>
            {provider?.malpractice_insurance_applications?.map((insurance, index) => (
              <div key={'Insurance' + index}>
                <div className="border-top"> </div>
                <Row className="align-items-center py-3">
                  <Col>Insurance certificate #{index + 1}</Col>
                  <Col xs="auto">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      href={insurance.file}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <BsDownload className="tw:inline" /> Download
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            {!provider?.malpractice_insurance_applications?.length && (
              <span className="d-block">No insurance certificates registered</span>
            )}
          </div>
        </Card.SubCard>
        <Card.SubCard className="p-3 pb-0 mb-3">
          <div className="p-3">
            <h5 className="pb-3 m-0">Other documents</h5>
            {provider?.miscellaneous?.map((record, index) => (
              <div className="border-top py-3" key={'Record' + index}>
                <span className="mb-2">Record #{index + 1}</span>
                <Row>
                  <Col xs={6} lg={3}>
                    <Card.Info label="Type">{record?.title}</Card.Info>
                  </Col>
                  <Col xs={6} lg={3}>
                    <Card.Info label="Issue Date">{record?.issue_date || 'N/A'}</Card.Info>
                  </Col>
                  <Col xs={6} lg={3}>
                    <Card.Info label="Expiration Date">
                      {record?.expiration_date || 'N/A'}
                    </Card.Info>
                  </Col>
                </Row>
                <Button
                  className="mt-3"
                  size="sm"
                  variant="outline-primary"
                  href={record.file.file}
                  target="_blank"
                  rel="noreferrer"
                >
                  <BsDownload className="tw:inline" /> Download
                </Button>
              </div>
            ))}
            {!provider?.miscellaneous?.length && (
              <span className="d-block">No other documents registered</span>
            )}
          </div>
        </Card.SubCard>
      </Col>
      <Col xs={12} md={6} className="mb-3">
        <Card.SubCard className="p-3 pb-0 mb-3">
          <div className="p-3">
            <h5 className="pb-3 m-0">Questionnaire</h5>
            <div className="border-top py-3">
              <Row className="align-items-center py-3">
                <Col>Provider’s Questionnaire</Col>
                <Col xs="auto">
                  {user?.user_type === UserTypeEnum.HEALTHCARE_ENTITY_REP && (
                    <>
                      {provider?.completed_questionnaire && (
                        <>
                          <Link
                            to={`/app/healthcare-entity/providers/${provider?.id}/questionnaire`}
                          >
                            <Button className="me-2" size="sm" variant="outline-primary">
                              Preview
                            </Button>
                          </Link>
                          <Button
                            size="sm"
                            onClick={() => downloadQuestionnaire(provider?.id)}
                            variant="outline-primary"
                            className="d-inline-flex align-items-center justify-content-space-between"
                          >
                            <BsDownload className="me-2 tw:inline" /> Download
                          </Button>
                        </>
                      )}
                      {!provider?.completed_questionnaire && (
                        <span>Provider hasn’t filled out questionnaire yet</span>
                      )}
                    </>
                  )}
                  {user?.user_type === UserTypeEnum.PROVIDER && provider?.id && (
                    <Link to={`/app/provider/questionnaire/${provider?.id}`}>
                      <Button size="sm" variant="outline-primary">
                        {provider?.completed_questionnaire
                          ? 'Update Answers'
                          : 'Fill Out Questionnaire'}
                      </Button>
                    </Link>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </Card.SubCard>
        <Card.SubCard className="p-3 pb-0 mb-3">
          <div className="p-3">
            <h5 className="pb-3 m-0">Immunization Certificates</h5>
            {provider?.immunizations?.map((immunization, index) => (
              <div className="border-top py-3" key={'Immunization' + index}>
                <span className="mb-2">Immunization #{index + 1}</span>
                <Row>
                  <Col xs={6} lg={3}>
                    <Card.Info label="Type">
                      {immunization?.type ? window.IMMUNIZATION_TYPES[immunization.type] : 'N/A'}
                    </Card.Info>
                  </Col>
                  <Col xs={6} lg={3}>
                    <Card.Info label="Issue Date">{immunization?.issue_date || 'N/A'}</Card.Info>
                  </Col>
                  <Col xs={6} lg={3}>
                    <Card.Info label="Expiration Date">
                      {immunization?.expiration_date || 'N/A'}
                    </Card.Info>
                  </Col>
                  <Col xs={6} lg={3}>
                    {immunization?.exempt && <Card.Info label="Exempt">✅</Card.Info>}
                  </Col>
                </Row>
                <Button
                  className="mt-3"
                  size="sm"
                  variant="outline-primary"
                  href={immunization.file.file}
                  target="_blank"
                  rel="noreferrer"
                >
                  <BsDownload className="tw:inline" /> Download
                </Button>
              </div>
            ))}
            {!provider?.immunizations?.length && (
              <span className="d-block">No immunization certificates registered</span>
            )}
          </div>
        </Card.SubCard>
      </Col>
    </Row>
  );
};
